// API service functions for WhatsApp alerts
import api from './client';

export interface WhatsAppAlert {
  id: number;
  phone_number: string;
  service: string;  // discipline_alerts, offline_alerts, etc.
  store_ids: string[];
  org_id: string;
  is_active: boolean;
  granted_by: string;
  created_at: string;
  updated_at: string;
}

export interface WhatsAppAlertCreate {
  phone_number: string;
  service: string;  // discipline_alerts, offline_alerts, etc.
  store_ids: string[];
  org_id: string;
  is_active?: boolean;
  granted_by?: string;
}

export interface WhatsAppAlertUpdate {
  store_ids?: string[];
  is_active?: boolean;
}

export const whatsappApi = {
  // Create WhatsApp alert
  create: async (data: WhatsAppAlertCreate): Promise<WhatsAppAlert> => {
    const response = await api.post('/v1/whatsapp/', data);
    return response.data;
  },

  // List all WhatsApp alerts
  list: async (skip = 0, limit = 100): Promise<WhatsAppAlert[]> => {
    const response = await api.get(`/v1/whatsapp/?skip=${skip}&limit=${limit}`);
    return response.data;
  },

  // List WhatsApp alerts by organization
  listByOrg: async (orgId: string): Promise<WhatsAppAlert[]> => {
    const response = await api.get(`/v1/whatsapp/org/${orgId}`);
    return response.data;
  },

  // Get WhatsApp alerts by phone number (returns array)
  getByPhone: async (phoneNumber: string, service?: string): Promise<WhatsAppAlert[]> => {
    const params = service ? `?service=${service}` : '';
    const response = await api.get(`/v1/whatsapp/phone/${phoneNumber}${params}`);
    return response.data;
  },

  // Update stores for a phone number + service
  updateStores: async (phoneNumber: string, service: string, data: WhatsAppAlertUpdate): Promise<WhatsAppAlert> => {
    const response = await api.put(`/v1/whatsapp/${phoneNumber}/stores?service=${service}`, data);
    return response.data;
  },

  // Update WhatsApp alert by ID
  update: async (alertId: number, data: WhatsAppAlertUpdate): Promise<WhatsAppAlert> => {
    const response = await api.put(`/v1/whatsapp/${alertId}`, data);
    return response.data;
  },

  // Delete (soft delete) WhatsApp alert
  delete: async (alertId: number): Promise<{ message: string }> => {
    const response = await api.delete(`/v1/whatsapp/${alertId}`);
    return response.data;
  },

  // Hard delete WhatsApp alert (admin only)
  hardDelete: async (alertId: number): Promise<{ message: string }> => {
    const response = await api.delete(`/v1/whatsapp/${alertId}/hard`);
    return response.data;
  },
};
